import { MdOutlineClose } from "react-icons/md";
import NavLinks from "./NavLinks";
import NavbarButton from "./NavbarButton";

const SideMenu = ({ isOpen, toggleMenu }) => {
	return (
		<div className={'side-menu'} style={{ right: isOpen ? 0 : '-100%' }}>
			<MdOutlineClose onClick={toggleMenu} />
			<h2>AAYOJAN</h2>
			<NavbarButton />
			<NavLinks />
		</div>
	);
};

export default SideMenu;
